module.exports = "<input name=\"pictureFile\" data-files=\"https://i.imgur.com/awSmPZy.png,files/medias/logos/logo_v3_1.png\" type=\"file\" data-allowed=\"jpg,jpeg,pdf,csv\" accept=\"image/*,application/*\" placeholder=\"Téléchargez une photo\" data-classLabel=\"btn-bd-primary\" data-classWrapper=\"bd-primary\" data-maxfiles=\"0\" multiple> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader?interpolate!./src/components/fileUploader/sample.html
// module id = 66
// module chunks = 0